/* Eget samtykkebanner (økt 19e). Markup og tekster: sections/samtykkebanner.liquid. Logikk: docs/varesystem/logikk/samtykkebanner.md (Admin-repoet).
   - Samtykket lagres bare med Shopifys Customer Privacy API (setTrackingConsent), aldri i egne informasjonskapsler.
   - Banneret vises når Shopify sier det (shouldShowBanner), eller når kunden ikke har svart og Shopifys innstillinger ikke tillater noen av
     formålene uten samtykke (dokumentasjonen sier ikke hva shouldShowBanner gir når Shopifys eget banner er fjernet). Ingen egen landliste.
   - Mangler API-et (sjekkes i 30 s): ingenting vises og ingenting lagres (Shopifys standard der samtykke kreves er da at ingenting er tillatt).
   - Banneret lukkes først når Shopify har bekreftet lagringen (tilbakekallet). Feil: melding, banneret står.
   - Lenker til «#informasjonskapsler» åpner innstillingene igjen, så samtykket kan trekkes like lett som det ble gitt. */
(function () {
  'use strict';
  const rot = document.getElementById('gg-samtykke');
  if (!rot || rot.dataset.klar) return;
  rot.dataset.klar = '1';

  const banner = rot.querySelector('[data-gg-sb-banner]');
  const bak = rot.querySelector('[data-gg-sb-pref-bak]');
  const pref = rot.querySelector('[data-gg-sb-pref]');
  const kvittering = rot.querySelector('[data-gg-sb-kvittering]');
  const brytere = Array.from(pref.querySelectorAll('input[data-formal]'));
  const ANKER = '#informasjonskapsler';
  let apnetAv = null; // elementet som fikk fokus før innstillingene åpnet
  let lagrer = false;

  function api() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.setTrackingConsent === 'function' && typeof cp.currentVisitorConsent === 'function' ? cp : null;
  }

  function lastApi() {
    return new Promise((ferdig) => {
      if (api()) return ferdig(api());
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return ferdig(null);
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (feil) => ferdig(feil ? null : api()));
      } catch (e) {
        ferdig(null);
      }
    });
  }

  function samtykke(cp) {
    try {
      return cp.currentVisitorConsent() || {};
    } catch (e) {
      return {};
    }
  }

  function skalVises(cp) {
    const c = samtykke(cp);
    const ikkeSvart = !c.marketing && !c.analytics && !c.preferences;
    if (!ikkeSvart) return false;
    try {
      if (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()) return true;
    } catch (e) { /* faller til sjekken under */ }
    try {
      return !cp.marketingAllowed() || !cp.analyticsProcessingAllowed() || !cp.preferencesProcessingAllowed();
    } catch (e) {
      return false;
    }
  }

  /* Plass under siden mens banneret er åpent */
  let maaler = null;
  function oppdaterHoyde() {
    document.documentElement.style.setProperty('--gg-sb-hoyde', banner.hidden ? '0px' : banner.offsetHeight + 'px');
    document.body.classList.toggle('gg-sb-apen', !banner.hidden);
  }
  function visBanner() {
    banner.hidden = false;
    oppdaterHoyde();
    if (!maaler && 'ResizeObserver' in window) {
      maaler = new ResizeObserver(oppdaterHoyde);
      maaler.observe(banner);
    }
  }
  function skjulBanner() {
    banner.hidden = true;
    oppdaterHoyde();
  }

  function visFeil(sted, tekst) {
    rot.querySelectorAll('[data-gg-sb-feil]').forEach((el) => {
      const her = sted.contains(el);
      el.hidden = !(her && tekst);
      el.textContent = her && tekst ? tekst : '';
    });
  }

  function vent(av) {
    lagrer = av;
    rot.querySelectorAll('button, input[data-formal]').forEach((b) => { b.disabled = av; });
    rot.setAttribute('aria-busy', av ? 'true' : 'false');
  }

  /* Innstillingene */
  function fokuserbare() {
    return Array.from(pref.querySelectorAll('button, input, a[href]')).filter((el) => !el.disabled && el.offsetParent !== null);
  }
  function apneInnstillinger(fra) {
    const cp = api();
    if (!cp) return false;
    const c = samtykke(cp);
    brytere.forEach((b) => { b.checked = c[b.dataset.formal] === 'yes'; });
    apnetAv = fra || document.activeElement;
    visFeil(pref, '');
    bak.hidden = false;
    if (!banner.hidden) banner.inert = true;
    document.documentElement.classList.add('gg-sb-laast');
    pref.focus();
    return true;
  }
  function lukkInnstillinger() {
    if (bak.hidden) return;
    bak.hidden = true;
    banner.inert = false;
    document.documentElement.classList.remove('gg-sb-laast');
    const til = apnetAv && document.contains(apnetAv) && apnetAv.offsetParent !== null ? apnetAv : banner.hidden ? null : banner.querySelector('[data-gg-sb-velg]');
    apnetAv = null;
    if (til) til.focus();
  }

  /* Én lagring om gangen, og knappene står låst til Shopify har svart, så to valg aldri kappes (codex runde 2). Svarer ikke Shopify innen
     10 s, vises en melding om å laste siden på nytt; kommer svaret senere, lukkes banneret som vanlig. */
  function lagre(valg, sted) {
    const cp = api();
    if (!cp || lagrer) return;
    vent(true);
    visFeil(sted, '');
    let svart = false;
    const tidsur = setTimeout(() => { if (!svart) visFeil(sted, rot.dataset.treg); }, 10000);
    const ferdig = (svar) => {
      if (svart) return;
      svart = true;
      clearTimeout(tidsur);
      vent(false);
      if (svar && svar.error) {
        visFeil(sted, rot.dataset.feil);
        return;
      }
      visFeil(sted, '');
      const fraBanner = !banner.hidden;
      skjulBanner();
      const fokus = apnetAv;
      lukkInnstillinger();
      if (!fraBanner) {
        kvittering.textContent = rot.dataset.lagret;
        setTimeout(() => { kvittering.textContent = ''; }, 4000);
      }
      if (!fokus || !document.contains(fokus) || fokus.offsetParent === null) {
        const main = document.getElementById('main-content');
        if (main && fraBanner) { main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); }
      }
    };
    try {
      cp.setTrackingConsent({ analytics: !!valg.analytics, marketing: !!valg.marketing, preferences: !!valg.preferences }, ferdig);
    } catch (err) {
      ferdig({ error: err });
    }
  }

  rot.addEventListener('click', (e) => {
    const k = e.target.closest('button');
    if (!k || k.disabled) return;
    const sted = bak.contains(k) ? pref : banner;
    if (k.hasAttribute('data-gg-sb-godta')) lagre({ analytics: true, marketing: true, preferences: true }, sted);
    else if (k.hasAttribute('data-gg-sb-avsla')) lagre({ analytics: false, marketing: false, preferences: false }, sted);
    else if (k.hasAttribute('data-gg-sb-velg')) apneInnstillinger(k);
    else if (k.hasAttribute('data-gg-sb-lukk')) lukkInnstillinger();
    else if (k.hasAttribute('data-gg-sb-lagre')) {
      const valg = {};
      brytere.forEach((b) => { valg[b.dataset.formal] = b.checked; });
      lagre(valg, pref);
    }
  });
  bak.addEventListener('click', (e) => { if (e.target === bak && !lagrer) lukkInnstillinger(); });
  document.addEventListener('keydown', (e) => {
    if (bak.hidden) return;
    if (e.key === 'Escape' && !lagrer) { e.preventDefault(); lukkInnstillinger(); return; }
    if (e.key !== 'Tab') return;
    const liste = fokuserbare();
    if (!liste.length) { e.preventDefault(); pref.focus(); return; } // alt er låst mens Shopify lagrer
    const forste = liste[0];
    const siste = liste[liste.length - 1];
    if (e.shiftKey && (document.activeElement === forste || document.activeElement === pref)) { e.preventDefault(); siste.focus(); }
    else if (!e.shiftKey && document.activeElement === siste) { e.preventDefault(); forste.focus(); }
    else if (!pref.contains(document.activeElement)) { e.preventDefault(); forste.focus(); }
  });

  /* «Informasjonskapsler» i bunnen (og andre lenker til ankeret) */
  function erAnkerlenke(a) {
    const href = a.getAttribute('href') || '';
    return href === ANKER || href.endsWith(ANKER);
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || !erAnkerlenke(a) || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (!api()) return; // uten API-et går lenken dit den peker
    e.preventDefault();
    apneInnstillinger(a);
  });
  window.addEventListener('hashchange', () => {
    if (location.hash === ANKER && api()) apneInnstillinger(null);
  });

  let startet = false;
  function start(cp) {
    if (!cp || startet) return;
    startet = true;
    if (skalVises(cp)) visBanner();
    if (location.hash === ANKER) apneInnstillinger(null);
  }
  // API-et sjekkes hvert sekund i 30 s, uavhengig av om loadFeatures svarer, og loadFeatures kalles én gang når den finnes (codex runde 2)
  let lastet = false;
  let forsok = 0;
  function sjekkApi() {
    if (startet) return;
    if (api()) return start(api());
    if (!lastet && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      lastet = true;
      lastApi().then(start);
    }
    if (++forsok <= 30) setTimeout(sjekkApi, 1000);
  }
  sjekkApi();
})();
